import { configService } from '../../../../services/ConfigService';
import ScoreLineChart from '../../../Charts/ScoreLineChart';

export default {
    name: 'topic-details',
    components: {
        ScoreLineChart
    },
    props: {
        questionnaire: Object,
        topics: Array,
        selectedTopic: Object
    },
    data() {
        return {
            questionEstimateInSeconds: configService.get('questionnaire.defaultQuestionEstimate'),
            scoreChartData: this.getDefaultScoreChartData(),
            dataLoaded: false
        }
    },
    computed: {
        topicEstimate() {
            let self = this,
                questionsCount = 0,
                result = {
                    number: 0,
                    label: 'minute'
                };

            if (self.selectedTopic.answeredQuestionsCount > 0) {
                questionsCount = self.selectedTopic.questionsCount - self.selectedTopic.answeredQuestionsCount;
            } else {
                questionsCount = self.selectedTopic.allQuestionsCount;
            }

            if (questionsCount > 0) {
                result.number = questionsCount * self.questionEstimateInSeconds;
            }

            if (result.number < 60) {
                result.label = 'second';
            } else if (result.number % 60 <= 30) {
                result.number = Math.floor(result.number / 60);
            } else {
                result.number = Math.round(result.number / 60);
            }

            if (result.number > 1) {
                result.label += 's';
            }

            return result;
        }
    },
    mounted() {
        this.loadScoresData();
    },
    methods: {
        async loadScoresData() {
            let self = this,
                currentDate = new Date(),
                previousYear = new Date(currentDate.setFullYear(currentDate.getFullYear() - 1)),
                filterDate = previousYear.getFullYear() +
                    "-" + (previousYear.getMonth() + 1) +
                    "-" + previousYear.getDate();

            self.dataLoaded = false;

            await this.$authManager.getUser(function (user) {
                self.$api.getTopicScores(self.selectedTopic.id, filterDate, user).then(function (result) {
                    self.scoreChartData = {
                        id: self.selectedTopic.id,
                        currentScore: self.selectedTopic.score,
                        annualScores: result.annualTopicScores
                    };
                    self.dataLoaded = true;
                });
            });
        },

        getDefaultScoreChartData() {
            let self = this,
                currentDate = new Date(),
                previousYear = new Date(currentDate.setFullYear(currentDate.getFullYear() - 1)),
                filterDate = previousYear.getFullYear() +
                    "-" + (previousYear.getMonth() + 1) +
                    "-" + previousYear.getDate(),
                result = {
                    id: null,
                    currentScore: self.selectedTopic.score,
                    annualScores: {
                    }
                };

            result.annualScores[filterDate] = 300;

            return result;
        }
    }
}
